<div class="flex-wrap" style="align-items: center;">
  <h1 class="inline-flex">Reuniones</h1>
  <span class="spacer"></span>
  <button mat-icon-button
          style="margin-left: 100px;"
          (click)="openSearch()"
          [ngStyle]="{'opacity': searchState ? '1' : '.6'}">
    <mat-icon>search</mat-icon>
  </button>
  <button mat-icon-button
          (click)="toggleFilters()"
          [ngStyle]="{'opacity': filtersState ? '1' : '.6'}">
    <mat-icon>filter_list</mat-icon>
  </button>
</div>
